import { useCallback, useMemo } from 'react';
import {
  useSkillCommand,
  useAttachedImageTooltipState,
  useImageMaskingPanelActions,
  useAttachFile,
} from 'src/hooks';

export const useImageMaskingEditClick = () => {
  const { sendReceivedFile } = useAttachFile();
  const { setEditingMode } = useImageMaskingPanelActions();
  const { isAttachedImageEditingMode } = useAttachedImageTooltipState();
  const { activeSkillCommand, toggleActiveSkillCommand } = useSkillCommand();

  const enableEditingMode = useCallback(
    async ({ currentImageUrl }: { currentImageUrl: string }) => {
      if (!currentImageUrl) {
        return;
      }

      if (activeSkillCommand) {
        toggleActiveSkillCommand(null);
      }
      setEditingMode(true);

      if (!isAttachedImageEditingMode) {
        await sendReceivedFile(currentImageUrl);
      }
    },
    [
      activeSkillCommand,
      isAttachedImageEditingMode,
      sendReceivedFile,
      setEditingMode,
      toggleActiveSkillCommand,
    ],
  );

  return useMemo(
    () => ({
      enableEditingMode,
    }),
    [enableEditingMode],
  );
};
